import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./Portfolio.css";
import { FaArrowRight } from "react-icons/fa6";
import { projects } from "../../data";
import Reveal from "../motion/Reveal";
import { staggerContainer, staggerItem } from "../motion/variants";

const Portfolio = () => {
  const [items, setItems] = useState(projects);
  const [activeTab, setActiveTab] = useState("All");
  const [seen, setSeen] = useState(false); // the grid has scrolled into view at least once

  const filterItems = (category) => {
    if (category === "All") {
      setItems(projects);
    } else {
      setItems(projects.filter((p) => p.category === category));
    }
    setActiveTab(category);
  };

  return (
    <Reveal as="section" id="portfolio">
      <h5 className="title">My Recent Work</h5>
      <h2>Projects</h2>
      <div className="container">
        {/* Filter tabs */}
        <div className="filter-tabs">
          {["All", "Websites", "E-books"].map((tab) => (
            <span
              key={tab}
              className={activeTab === tab ? "active" : ""}
              onClick={() => filterItems(tab)}
            >
              {tab === "Mobile Applications" ? "Mobile Apps" : tab}
            </span>
          ))}
        </div>

        {/* Grid — keyed by tab so every tab change replays the entrance animation. The first
            reveal waits for the grid to scroll into view; after that `animate` drives it, because
            cards mounted after a one-time `whileInView` would stay in their "hidden" state. */}
        <motion.div
          key={activeTab}
          className="portfolio__container"
          initial="hidden"
          animate={seen ? "visible" : "hidden"}
          onViewportEnter={() => setSeen(true)}
          viewport={{ once: true, amount: "some" }}
          variants={staggerContainer}
        >
          {items.map(({ id, image, title, description, demo, caseStudy, keywords, category }) => (
            <motion.div
              key={id}
              className="card"
              variants={staggerItem}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 300, damping: 22 }}
            >
              {/* Image */}
              <div className="thumb">
                <img src={image} alt={title} loading="lazy" />
                <span className="category-badge">{category}</span>
                {caseStudy ? (
                  <div className="thumb__overlay">
                    <Link to={caseStudy} className="thumb__btn">
                      View Case Study <FaArrowRight size={12} />
                    </Link>
                  </div>
                ) : demo && (
                  <div className="thumb__overlay">
                    <a href={demo} className="thumb__btn" target="_blank" rel="noreferrer">
                      View Project <FaArrowRight size={12} />
                    </a>
                  </div>
                )}
              </div>

              {/* Body — always visible */}
              <div className="card__body">
                <div className="tags">
                  {keywords.map((k, i) => (
                    <span className="tag" key={i}>{k}</span>
                  ))}
                </div>
                <h3>{title}</h3>
                {description && <p>{description}</p>}
                {caseStudy ? (
                  <Link to={caseStudy} className="card__cta">
                    View Case Study <FaArrowRight size={11} />
                  </Link>
                ) : demo ? (
                  <a href={demo} className="card__cta" target="_blank" rel="noreferrer">
                    View Project <FaArrowRight size={11} />
                  </a>
                ) : (
                  <span className="card__cta card__cta--unavailable">No live demo</span>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </Reveal>
  );
};

export default Portfolio;
